import { betaMainnetConfig } from "./betaMainnetConfig";
import { mainnetConfig } from "./mainnet";
import { testnetConfig } from "./testnetConfig";

let con = null;
switch (process?.env?.NEXT_PUBLIC_NETWORK) {
  case "mainnet":
    con = mainnetConfig;
    break;
  case "betamainnet":
    con = betaMainnetConfig;
    break;
  case "testnet":
    con = testnetConfig;
    break;
  default:
    con = testnetConfig;
}
export const config = mainnetConfig;
